<template>
  <a :href="target || 'javascript:;'" :class="['card', ...modifierClasses]">
    <div v-if="hasImageSlot" class="card__image">
      <slot name="card-image"></slot>
    </div>
    <div class="card__body">
      <div v-if="hasChipSlot" class="card__chip-row">
        <slot name="chip-row"></slot>
      </div>
      <div v-if="hasContentSlot" class="card__content">
        <slot name="card-content"></slot>
      </div>
    </div>
    <div v-if="hasActionSlot" class="card__action">
      <slot name="card-action"></slot>
    </div>
  </a>
</template>

<script>
export default {
  name: 'Card',
  props: {
    target: String,
    modifierClasses: Array
  },
  computed: {
    hasChipSlot () {
      return !!this.$slots['chip-row']
    },
    hasContentSlot () {
      return !!this.$slots['card-content']
    },
    hasActionSlot () {
      return !!this.$slots['card-action']
    },
    hasImageSlot () {
      return !!this.$slots['card-image']
    }
  }
}
</script>